import { render } from "./CustomFormInputNumber.vue?vue&type=template&id=49c05c26"
import script from "./CustomFormInputNumber.vue?vue&type=script&lang=js"
export * from "./CustomFormInputNumber.vue?vue&type=script&lang=js"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__